import styled from "styled-components";
import FaqImage from "../../assets/Faq.jpeg";
import { Link } from "react-router-dom";
const fontSize = localStorage.getItem('fontSize');

export const FaqHeader = styled.header`
  padding-top: 200px;
  width: 100%;
  background: url(${FaqImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media (width <= 768px) {
    padding-top: 300px;
  }
`;

export const FaqBadge = styled.div`
  position: absolute;
  align-self: center;
  background: #62aa51;
  z-index: 9999;
  left: 20%;
  width: 60%;
  padding: 2rem;
  margin-top: -3.5rem;
  text-align: center;
  color: white;
  @media (width <= 768px) {
    width: calc(100% - (9% + 9%));
    right: 9%;
    left: 9%;
  }
`;

export const NavLinksContainer = styled.nav`
  position: absolute;
  top: 90px;
  left: 2rem;
  color: white;
  display: flex;
  align-items: center;
`;

export const FaqTitle = styled.h1`
  position: absolute;
  color: white;
  top: 140px;
  left: 2rem;
`;

export const NavLink = styled(Link)`
  color: #000;
  font-size: calc(${fontSize} - 0.3rem);
  color: white;
`;

export const FaqContainer = styled.div`
  padding-top: 5rem;
  margin: 0 auto;
  display: flex;
  width: 60%;
  gap: 0.5rem;
  @media (width <= 768px) {
    width: 82%;
    flex-direction: column;
    gap: 2px;
  }
`;

export const QuestionButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  position: sticky;
  top: 1.5rem;
  width: 40%;
  height: 20rem;
  @media (width <= 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    position: static;
    height: 10rem;
    width: 100%;
  }
  @media (width <= 400px) {
    margin-top: 3rem;
  }
`;

export const QuestionButton = styled.button`
  background: #fff;
  width: 100%;
  color: #101e8e;
  height: 20%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 2 1;
  @media (width <= 768px) {
    b {
      font-size: calc(${fontSize} - 0.2rem);
    }
  }
`;

export const AnswerContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;
